// extracted by mini-css-extract-plugin
export default {"firstWizard":"FirstWizard_firstWizard__A2Kuc"};